import Liveness from "./Liveness";
import LoadScriptFilesService from "../LoadScriptFilesService";
const PATH = 'static/selfie/livenessFacetec/';

export default class LivenessFacetec extends Liveness{

    carregarArquivos(id) {
        let loadScript =  new LoadScriptFilesService();
        return loadScript.head_script(PATH+'brscan-sdk-selfie-facetec.min.js',id,'high');
    }

    preLoad() {
        const corPrimaria = "#660099";
        const fontColor = "#000000";
        const fontFamily = "VivoType";
        const TEXTO_ROSTO = 'Enquadre seu rosto na moldura';
        window.selfie = new window.BrScanSDKSelfie.Selfie(this.$store.state.chave);
        window.selfie.wizzard = false;
        window.selfie.btnNormalColor = corPrimaria;
        window.selfie.btnNormalColor = corPrimaria;
        window.selfie.btnHighlightColor = corPrimaria;
        window.selfie.btnBorderColor = corPrimaria;
        window.selfie.ovalProgressColor1 = corPrimaria;
        window.selfie.ovalProgressColor2 = corPrimaria;
        window.selfie.corPrimaria = corPrimaria;
        window.selfie.btnDisabledColor = "#b27fcc";
        window.selfie.loadingBackgroundColor = corPrimaria;
        window.selfie.uploadProgressFillColor = corPrimaria;
        window.selfie.initialLoadingFont = fontFamily;
        window.selfie.readyScreenHeaderFont = fontFamily;
        window.selfie.readyScreenSubtextFont = fontFamily;
        window.selfie.loadingTextColor = fontColor;
        window.selfie.readyScreenHeaderTextColor = fontColor;
        window.selfie.readyScreenSubtextColor = fontColor;
        window.selfie.initialButtonFont =  fontColor;
        window.selfie.botaoCancelar = false;
        window.selfie.objTextos = {
            FaceTec_instructions_message_ready_desktop:TEXTO_ROSTO,
            FaceTec_instructions_message_ready_1_mobile:TEXTO_ROSTO,
            FaceTec_presession_frame_your_face:TEXTO_ROSTO,
            FaceTec_instructions_header_ready_desktop:'Se prepare pra tirar a foto',
            FaceTec_instructions_header_ready_2_mobile: 'pra tirar a foto',
            FaceTec_instructions_message_ready_2_mobile: 'e pressione "tudo pronto"',
            FaceTec_action_im_ready: 'Tudo pronto',
            FaceTec_retry_your_image_label:'Sua foto',
            FaceTec_retry_ideal_image_label:"Foto ideal"
        }
    }

    getRouteName() {
        return "Selfie";
    }

}



// WEBPACK FOOTER //
// ./src/services/liveness/LivenessFacetec.js